import { useQuery } from '@apollo/client';
import { getOutliersForManagerQuery } from './queries';
import { OutlierTimeOption } from '@amzn/aet-dynamo-kit';
import { isFeatureEnabled, Feature } from '../../config/FeaturesConfig';
import { RawOutlier } from './schema';

const CCX_BOTTOM_BACKEND_CATEGORY = 'ccx_bottom_twobox_twentyfive';
const ACHT_BOTTOM_BACKEND_CATEGORY = 'acht_bottom_ten';

const useOutliersForManager = (
  managerAlias: string,
  isOm: boolean,
  timeOption: OutlierTimeOption,
  timestamps: string[]
) => {
  const { loading, error, data, refetch } = useQuery(
    getOutliersForManagerQuery,
    {
      variables: {
        managerAlias,
        isOm,
        timeOption,
        timestamps,
      },
      fetchPolicy: 'cache-and-network', // For real-time updates
    }
  );
  const rawOutliers: RawOutlier[] = data?.getOutliersForManager ?? [];

  // Filter out outlier categories based on feature flags
  const outliers = rawOutliers.filter(outlier => {
    // Filter out CCX Bottom 25% when enableCCXRemoval is enabled
    if (
      isFeatureEnabled(Feature.ENABLE_CCX_REMOVAL) &&
      outlier.category === CCX_BOTTOM_BACKEND_CATEGORY
    ) {
      return false;
    }
    // Filter out ACHT Bottom 10% when achtFlag is disabled
    if (
      !isFeatureEnabled(Feature.ACHT_FLAG) &&
      outlier.category === ACHT_BOTTOM_BACKEND_CATEGORY
    ) {
      return false;
    }
    return true;
  });

  return {
    loading,
    error,
    data: outliers,
    refetch,
  };
};

export default useOutliersForManager;
